/**
 * Địa chỉ ảnh cho khung ảnh chuẩn (`components/PhotoThumb`).
 *
 * Tách khỏi tệp thành phần vì tệp đó chỉ được xuất thành phần (làm mới nóng
 * của Vite), và vì nhiều bài kiểm giả lập `lib/upload` chỉ khai vài hàm —
 * tách riêng để ai cần giả lập cũng thấy rõ phụ thuộc.
 */
import { freshOriginalUrl } from "@/lib/fresh-upload";
import { imageUrl, type Variant } from "@/lib/upload";

/**
 * Địa chỉ trình duyệt dùng THẲNG được, không ghép biến thể kho: URL đầy đủ
 * (bill, ảnh chat, ảnh gốc vừa tải), ảnh xem trước tại máy (`blob:`, `data:`)
 * và đường dẫn tương đối của máy chủ. Đưa `blob:` qua `imageUrl` là thành
 * `<cdn>/blob:…/md.webp` — ảnh vỡ. Chỉ CON TRỎ kho mới cần ghép biến thể và
 * thử lại khi biến thể chưa sinh (`VariantImage`).
 */
export function isDirectPhotoSrc(src: string): boolean {
  return /^(https?:|blob:|data:|\/)/i.test(src);
}

/**
 * Địa chỉ một biến thể của ảnh. Ảnh VỪA tải lên trong phiên thì trả ảnh gốc:
 * biến thể chưa sinh, xin sớm là nhận 404 và CDN ghim 404 đó một năm (xem
 * `lib/fresh-upload.ts`).
 */
export function photoUrl(src: string, variant: Variant): string {
  if (!src || isDirectPhotoSrc(src)) return src;
  return freshOriginalUrl(src) ?? imageUrl(src, variant);
}
